var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickveeCustom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1246_2650",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1246_2650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25V3M12 21V18.75M18.75 12V21M18.75 3V7.5M5.25 9.75V21M5.25 3V5.25M13.875 18.375C14.1151 18.1349 14.25 17.8092 14.25 17.4697V15.5303C14.25 15.1908 14.1151 14.8651 13.875 14.625C13.6349 14.3849 13.3092 14.25 12.9697 14.25H11.0303C10.6908 14.25 10.3651 14.3849 10.125 14.625C9.88489 14.8651 9.75 15.1908 9.75 15.5303V17.4697C9.75 17.8092 9.88489 18.1349 10.125 18.375C10.3651 18.6151 10.6908 18.75 11.0303 18.75H12.9697C13.3092 18.75 13.6349 18.6151 13.875 18.375ZM16.875 7.87499C16.6349 8.11509 16.5 8.44077 16.5 8.78033V10.7197C16.5 11.0592 16.6349 11.3849 16.875 11.625C17.1151 11.8651 17.4408 12 17.7803 12H19.7197C20.0592 12 20.3849 11.8651 20.625 11.625C20.8651 11.3849 21 11.0592 21 10.7197V8.78033C21 8.44077 20.8651 8.11509 20.625 7.87499C20.3849 7.63489 20.0592 7.5 19.7197 7.5H17.7803C17.4408 7.5 17.1151 7.63489 16.875 7.87499ZM4.28033 5.25H6.21967C6.55923 5.25 6.88491 5.38488 7.12501 5.62499C7.36511 5.86509 7.5 6.19077 7.5 6.53033V8.46967C7.5 8.80923 7.36511 9.13491 7.12501 9.37501C6.88491 9.61511 6.55923 9.75 6.21967 9.75H4.28033C3.94077 9.75 3.61509 9.61511 3.37499 9.37501C3.13489 9.13491 3 8.80923 3 8.46967V6.53033C3 6.19077 3.13489 5.86509 3.37499 5.62499C3.61509 5.38488 3.94077 5.25 4.28033 5.25Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickveeCustom);
export default __webpack_public_path__ + "static/media/QuickveeCustom.cc90ac3c7cbd64f36f63fabaa151eb0e.svg";
export { ForwardRef as ReactComponent };